import { useQuery } from "@apollo/client";
import { Suspense } from "react";
import { useIntl } from "react-intl";

import Suspender from "lib/Suspender";
import { WorkspaceFinancialsDoc } from "operations";

import { LoadingSkeleton } from "@joor/design-system";
import { totalUnits } from "./ProductCount";
import { StyledContent, StyledLabel, StyledTitle } from "./styledComponents";

const useColorCount = (workspaceId: string, isBrand: boolean) => {
  const { data, loading } = useQuery(WorkspaceFinancialsDoc, {
    variables: { workspaceId },
  });

  const mappedUnits = data?.retailWorkspace?.assortments?.flatMap((a) =>
    a.financialOverview.financialDetails
      ?.filter((c) =>
        isBrand ? c.isBrandCurrency === true : c.isBrandCurrency === false
      )
      .map((c) => ({ currency: c.currencyCode, unit: c.units.colorCount }))
  );
  const colors = totalUnits(mappedUnits);

  return { loading, colors };
};

export const ColorCount = ({
  workspaceId,
  moreCurrencies,
  isBrand,
}: {
  workspaceId: string;
  moreCurrencies: boolean;
  isBrand: boolean;
}) => {
  const intl = useIntl();
  const { loading, colors } = useColorCount(workspaceId, isBrand);

  const listColorsCount = colors?.map((count) => (
    <StyledTitle data-testid="color-count-value">
      {intl.formatNumber(count) ?? 0}
    </StyledTitle>
  ));

  return (
    <StyledContent>
      <StyledLabel>Colors</StyledLabel>
      <Suspense fallback={<LoadingSkeleton />}>
        <Suspender suspend={loading}>
          {moreCurrencies ? (
            listColorsCount
          ) : (
            <StyledTitle data-testid="color-count-value">
              {colors[0] ? intl.formatNumber(colors[0]) : 0}
            </StyledTitle>
          )}
        </Suspender>
      </Suspense>
    </StyledContent>
  );
};
